import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    instructions: [],
};

export const instructionsSlice = createSlice({
    name: 'instructionsSlice',
    initialState,
    reducers: {
        
        getAllInstructions: (state, action) => {
            state.instructions = action.payload;
        },
        
    },
});

// Action creators are generated for each case reducer function
export const { getAllInstructions} = instructionsSlice.actions;

export default instructionsSlice.reducer;
